import { render, staticRenderFns } from "./VersionTask.vue?vue&type=template&id=35a4c198&"
import script from "./VersionTask.vue?vue&type=script&lang=js&"
export * from "./VersionTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports